(() => {
  const cache = new Map();
  const pattern = /^\s*\[\[card:\s*([^\]]+?)\s*\]\]\s*$/;
  function internalURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      return url;
    } catch { return null; }
  }
  async function metadata(url) {
    const key = url.origin + url.pathname + url.search;
    if (!cache.has(key)) cache.set(key, (async () => {
      const response = await fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
      if (!response.ok || new URL(response.url).origin !== location.origin) throw new Error('unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const meta = name => doc.querySelector(`meta[property="${name}"],meta[name="${name}"]`)?.content?.trim() || '';
      return {
        title: meta('og:title') || doc.querySelector('h1')?.textContent?.trim() || doc.title || url.pathname,
        description: meta('og:description') || meta('description'),
        image: meta('og:image')
      };
    })());
    return cache.get(key);
  }
  function scan() {
    document.querySelectorAll('.article-template__content').forEach(root => {
      root.querySelectorAll('p,div').forEach(element => {
        if (element.closest('.libase-link-card,pre,code') || element.querySelector('p,div,br,img,script,style')) return;
        const match = element.textContent.match(pattern);
        if (!match) return;
        const url = internalURL(match[1].trim());
        if (!url) return;
        const card = document.createElement('a');
        card.className = 'libase-link-card';
        card.href = url.href;
        const body = document.createElement('span');
        body.className = 'libase-link-card__body';
        const title = document.createElement('span');
        title.className = 'libase-link-card__title';
        title.textContent = url.pathname;
        body.append(title);
        card.append(body);
        element.replaceWith(card);
        metadata(url).then(data => {
          title.textContent = data.title;
          if (data.description) {
            const description = document.createElement('span');
            description.className = 'libase-link-card__description';
            description.textContent = data.description;
            body.append(description);
          }
          if (data.image) {
            let source;
            try { source = new URL(data.image, url); } catch { return; }
            if (!/^https?:$/.test(source.protocol)) return;
            const image = document.createElement('img');
            image.className = 'libase-link-card__image';
            image.src = source.href;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 160;
            image.height = 120;
            image.addEventListener('error', () => image.remove(), { once: true });
            card.prepend(image);
          }
        }).catch(() => {});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
